<template lang="pug">
  transition(name="fade")
    .Popup(
      @shortkey="close"
      @click="popupClose")

      transition(name="slide")
        .content(v-if="PAGE_SHOW")

          .header

            button.cancel(
              type="button"
              @click="close()")
              IconClose

            h3.title.u-text-width-bold
              template(v-if="is_edit")
                | {{ $t('generic.action._edit', [$t('generic.field.document_type.s')]) }}
              template(v-else)
                | {{ $t('generic.action._add', [$t('generic.field.document_type.s')]) }}

            template(v-if="is_edit")
              button.btn.btn-small.btn-danger.right-btn(
                type="button"
                @click="openDeleteModal")
                Loading(v-if="$wait.is('deleteDocumentType')")
                span(v-else) {{ $t('generic.action.delete') }}

          .body
            .row
              .col.col-full
                FormItem(
                  type="text"
                  field_name="name"
                  :validate="true"
                  :required="true"
                  v-model="document_type.name"
                  :label_text=" $t('generic.field.name') "
                  :data-vv-as=" $t('generic.field.name') "
                  v-validate="'max:64'"
                  :error="veeErrors.first('name')"
                )


          .footer
            button.cancel.btn.btn-line(
              type="button"
              @click="close()"
            ) {{ $t('generic.action.cancel') }}

            button.save.btn.btn-primary(
              type="button"
              @click="save"
              :disabled="is_loading")
              Loading(v-if="is_loading")
              span(v-else) {{ $t('generic.action.save') }}

      Modal(
        v-if="show_delete_modal"
        :acceptText=" $t('generic.action.delete') "
        :denyText=" $t('generic.action.cancel') "
        type="danger"
        :is_loading="$wait.is('deleteDocumentType')"
        @onAccept="onDelete"
        @onDeny="closeDeleteModal"
      )
        p {{ $t('generic.msg.confirmation') }}
</template>

<script>
  import {DocumentType} from '@/model/DocumentType'
  import {mapActions, mapState} from 'vuex'

  import _cloneDeep from 'lodash/cloneDeep'

  export default {
    name: 'DocumentTypePopup',

    data() {
      return {
        PAGE_SHOW: false,
        show_delete_modal: false,
        document_type: new DocumentType()
      }
    },

    created() {
      if (this.is_edit) {
        this.document_type = new DocumentType(_cloneDeep(this.$route.params.document_type))
      }
    },

    computed: {

      is_edit() {
        return this.$route.name === 'document-type-edit'
      },

      is_loading() {
        return this.$wait.is('createDocumentType')
      }

    },

    methods: {

      ...mapActions('DocumentType', [
        'createDocumentType',
        'deleteDocumentType'
      ]),

      popupClose(event) {
        if (event.target.classList.contains('Popup')) {
          this.close()
        }
      },

      close(reset = false) {
        this.$router.push({
          name: 'document-type'
        })
      },

      save() {
        this.$validator.validateAll().then(result => {
          if (!result) return
          this.createDocumentType({
            item: this.document_type,
            edit: this.is_edit
          })
            .then(res => {
              this.close()
            })
            .catch(err => {
              this.showErrorToast(this.$getErrorMessage(this, err))
            })
        })
      },

      onDelete() {
        this.deleteDocumentType(this.document_type.id).then(
          res => {
            this.close(true)
            this.showSuccessToast(this.$t('generic.msg.successful'))
          }
        ).catch(err => {
          this.closeDeleteModal()
          this.showErrorToast(this.$getErrorMessage(this, err))
        })
      },

      openDeleteModal() {
        this.show_delete_modal = true
      },

      closeDeleteModal() {
        this.show_delete_modal = false
      }

    },

    beforeRouteEnter(to, from, next) {
      next(vm => {
        setTimeout(() => {
          vm.PAGE_SHOW = true
        }, 0)
      })
    },

    beforeRouteLeave(to, from, next) {
      this.PAGE_SHOW = false
      setTimeout(() => {
        next()
      }, 150)
    }

  }
</script>
